"use strict";
/**
 * Address fallback constants for when location data is unavailable
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.FALLBACK_BASE_STATION_ADDRESS = void 0;
exports.FALLBACK_BASE_STATION_ADDRESS = '2700 Polaris Dr, Newport Beach, 92660 CA';
